const AltInstagramIcon = ({ color }: any) => {
  return (
    <svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M5.83268 2.29297C3.87667 2.29297 2.29102 3.87863 2.29102 5.83464V14.168C2.29102 16.124 3.87667 17.7096 5.83268 17.7096H14.166C16.122 17.7096 17.7077 16.124 17.7077 14.168V5.83464C17.7077 3.87863 16.122 2.29297 14.166 2.29297H5.83268ZM1.04102 5.83464C1.04102 3.18827 3.18632 1.04297 5.83268 1.04297H14.166C16.8124 1.04297 18.9577 3.18827 18.9577 5.83464V14.168C18.9577 16.8143 16.8124 18.9596 14.166 18.9596H5.83268C3.18632 18.9596 1.04102 16.8143 1.04102 14.168V5.83464ZM10.4326 7.28618C9.86913 7.20262 9.29363 7.29887 8.78799 7.56124C8.28234 7.82361 7.8723 8.23874 7.61619 8.74758C7.36007 9.25642 7.27093 9.83307 7.36143 10.3955C7.45193 10.9579 7.71747 11.4775 8.12028 11.8803C8.52309 12.2831 9.04266 12.5487 9.60509 12.6392C10.1675 12.7297 10.7442 12.6405 11.253 12.3844C11.7618 12.1283 12.177 11.7182 12.4393 11.2126C12.7017 10.707 12.798 10.1315 12.7144 9.56795C12.6292 8.99316 12.3613 8.46102 11.9504 8.05014C11.5396 7.63926 11.0074 7.37142 10.4326 7.28618ZM8.21227 6.45171C8.95129 6.06825 9.79241 5.92758 10.616 6.0497C11.4561 6.17427 12.2338 6.56573 12.8343 7.16625C13.4348 7.76678 13.8263 8.54452 13.9509 9.3846C14.073 10.2082 13.9323 11.0493 13.5489 11.7883C13.1654 12.5273 12.5587 13.1266 11.815 13.5009C11.0713 13.8753 10.2285 14.0056 9.4065 13.8733C8.58449 13.741 7.82512 13.3529 7.2364 12.7642C6.64768 12.1755 6.25958 11.4161 6.1273 10.5941C5.99503 9.77207 6.12532 8.92928 6.49964 8.18559C6.87396 7.4419 7.47325 6.83517 8.21227 6.45171ZM14.5823 4.48047C14.0645 4.48047 13.6448 4.9002 13.6448 5.41797C13.6448 5.93574 14.0645 6.35547 14.5823 6.35547H14.5906C15.1084 6.35547 15.5281 5.93574 15.5281 5.41797C15.5281 4.9002 15.1084 4.48047 14.5906 4.48047H14.5823Z'
        fill='url(#paint0_linear)'
      />
      <defs>
        <linearGradient
          id='paint0_linear'
          x1='1.04112'
          y1='20.239'
          x2='21.5173'
          y2='1.04258'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#FFDD55' />
          <stop offset='0.526042' stopColor='#FF543E' />
          <stop offset='1' stopColor='#C837AB' />
        </linearGradient>
      </defs>
    </svg>
  )
}

export default AltInstagramIcon
